import { definition, styles } from "@uesio/ui"

interface FieldLabelProps {
  label?: string
  // The id of the input element that this is the label for
  labelFor?: string
  required?: boolean
}

const StyleDefaults = Object.freeze({
  root: [],
  required: ["text-red-500", "ml-0.5"],
})

const FieldLabel: definition.UtilityComponent<FieldLabelProps> = (props) => {
  const { label, context, labelFor, required } = props
  const classes = styles.useUtilityStyleTokens(
    StyleDefaults,
    props,
    "uesio/io.fieldlabel",
  )
  return (
    <label className={classes.root} htmlFor={labelFor}>
      {context.mergeString(label)}
      {required && <span className={classes.required}>*</span>}
    </label>
  )
}

export default FieldLabel
